import keyBy from 'lodash/keyBy';
import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';
import dynamic from 'next/dynamic';
const Image = dynamic(()=>import('components/Image'));
import React, { Fragment, memo, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import Link from 'next/link';

import { QUESTIONS_LOADED } from '../../actions/types';
import {
    Average_cost,
    contact_for_price,
    Filter,
    Filters,
    Hired,
    Hourly_cost,
    No_pros_with_your_choice_yet,
    Reset,
    Save,
    Skip,
    starting_cost,
    View_profile,
} from '../../helpers/dictionary';
import GreyStar from '../../svgs/star-grey.svg';
import Star from '../../svgs/star.svg';
import Trophy from '../../svgs/trophy.svg';
import axios from '../../utils/axios';
import { displayPrice } from '../../utils/displayPrice';

const SearchCss = styled.div`
  position: relative;
  padding: 0 1.6rem;
  .filter-floating-button {
    position: fixed;
    bottom: 10%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    button {
      display: inline-block;
      padding: 1.3rem 3.6rem;
      letter-spacing: 1px;
      border: 0;
      border-radius: 4px;
      background: var(--color-french-violet);
      color: #fff;
      font-weight: 600;
      font-size: 1.4rem;
      box-shadow: 0 5px 25px #777;
      outline: none;
    }
  }
  .filters-modal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    z-index: 100;
    pointer-events: none;
    background-color: #fff;
    display: none;
    &.open {
      display: flex;
      flex-direction: column;
      pointer-events: inherit;
    }
    .close {
      height: 5.6rem;
      border-bottom: 1px solid #d3d4d5;
      display: flex;
      justify-content: flex-end;
      font-size: 1.6rem;
      button {
        width: 5rem;
        background-color: transparent;
        border: 0;
        outline: none;
      }
    }
    .filters-content {
      padding: 2rem;
      flex: 1;
      overflow-y: scroll;
      .header {
        display: flex;
        justify-content: space-between;
        h3 {
          font-size: 2rem;
          line-height: 2.8rem;
          margin: 0;
          letter-spacing: 1px;
        }
        button {
          font-size: 1.6rem;
          background-color: transparent;
          border: 0;
          color: var(--color-french-violet);
        }
      }
      .filter-data {
        margin-bottom: 2rem;
        h3 {
          font-size: 1.6rem;
          color: rgb(47, 48, 51);
        }
        .filter {
          margin-bottom: 1.2rem;
          label {
            display: flex;
            align-items: center;
            font-size: 1.4rem;
            input {
              margin-right: 0.8rem;
            }
          }
        }
      }
    }
    .modal-footer {
      border-top: 1px solid #d3d4d5;
      padding: 1.2rem 2.6rem;
      button {
        width: 100%;
        padding: 1.6rem 0;
        font-size: 1.6rem;
        background-color: var(--color-french-violet);
        color: white;
        border: 0;
        border-radius: 0.4rem;
        font-weight: bold;
        letter-spacing: 1px;
      }
    }
  }
  h1 {
    font-weight: 700;
    font-size: 2.2rem;
    color: var(--color-jet);
    margin-bottom: 0;
    margin-top: 3.2rem;
  }
  .contact-for-price h3 {
    margin: 0;
    font-size: 2.4rem;
  }
  .overlays {
    .overlay {
      position: absolute;
      width: 100%;
      left: 0;
      top: -1.7rem;
      background: white;
      z-index: 2;
      box-shadow: 0px 63px 50px rgb(0 0 0 / 7%);
      border-radius: 0px 0px 4px 4px;
      padding: 0 1.6rem;
      .overlay-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 2rem 0 1.6rem;
        h1 {
          margin: 0;
        }
        button {
          background: transparent;
          border: 0;
          padding: 0;
        }
      }
      .apply-changes {
        background: var(--color-flickr-blue);
        border-radius: 4px;
        border: 0;
        width: 100%;
        color: white;
        padding: 1.2rem 0;
        font-size: 1.5rem;
        font-weight: 600;
        margin: 2.4rem 0 2rem;
      }
    }
    .project-type-overlay {
      .filters-mobile-overlay {
        font-size: 1.5rem;
        color: #565459;
        span {
          margin-left: 1.2rem;
        }
        .filter {
          margin-bottom: 1.4rem;
        }
      }
    }
    .date-picker-overlay {
    }
  }
  .mobile-filters {
    display: flex;
    align-items: center;
    margin-top: 1.8rem;
    overflow-x: auto;
    overflow-y: hidden;
    button {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      height: 2rem;
      background-color: white;
      border: 0;
      border: 1px solid #dbdbdb;
      padding: 1.6rem 2rem;
      font-size: 1.3rem;
      color: #484848;
      margin-right: 1.2rem;
      border-radius: 3rem;
      background: #ececef;
      font-weight: 600;
      svg {
        margin-right: 0.8rem;
      }
      &.filter-active {
        background: var(--color-flickr-blue-shade);
        color: ${(props) => props.theme.colors.flickrBlue};
      }
    }
  }
  .mobile-filter-steps {
    margin: 2rem auto 0;
    .filter-header {
      display: flex;
      /* align-items: flex-start; */
      justify-content: space-between;
      h3 {
        font-size: 1.6rem;
        color: var(--color-jet);
        width: 75%;
        margin: 0;
      }
      button {
        font-size: 1.2rem;
        background: transparent;
        border: 0;
        padding: 0;
        color: var(--color-french-violet);
        font-weight: bold;
        outline: none;
      }
    }
    .filter-options {
      display: flex;
      position: relative;
      /* z-index: 40; */
      &::-webkit-scrollbar {
        display: none;
      }
      -ms-overflow-style: none;
      scrollbar-width: none; /* Firefox */
      overflow-x: auto;
      margin-top: 2rem;
      button {
        position: relative;
        flex: 0 0 auto;
        margin-right: 1rem;
        padding: 0.7rem 1.2rem;
        border-radius: 3rem;
        border: 1px solid #d3d4d5;
        color: #5f5f5f;
        background: transparent;
        font-size: 1.2rem;
        font-weight: bold;
        outline: none;
        &.active {
          color: #f5f5f5;
          background: var(--color-french-violet);
          border: 1px solid var(--color-french-violet);
        }
      }
    }
  }
  .mobile-filters-reset {
    display: flex;
    align-items: center;
    margin-top: 1.2rem;
    h5 {
      font-size: 1.6rem;
      margin: 0;
    }
    .reset {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      border: 0;
      background-color: transparent;
      border: 2px solid var(--color-flickr-blue);
      border-radius: 3rem;
      width: 2.6rem;
      height: 2.6rem;
      cursor: pointer;
      margin-left: 1.2rem;
      svg {
        margin: 0;
        padding: 0.2rem;
      }
    }
  }
  .filters {
    display: none;
  }
  .results {
    .results-data {
      margin-top: 2rem;
      border-top: 1.5px solid #e2e2e9;
      .item {
        margin: 1.4rem 0;
        padding-bottom: 1.4rem;
        justify-content: space-between;
        border-bottom: 1.5px solid #e2e2e9;
        .info {
          display: flex;
          .image {
            width: 12rem;
            height: 12rem;
            object-fit: cover;
            position: relative;
            img {
              border-radius: 4px;
              object-fit: cover;
            }
          }
          .details {
            margin-left: 1.6rem;
            h2 {
              margin: 0;
              font-size: 1.5rem;
              font-weight: 600;
              a {
                color: ${(props) => props.theme.colors.jet};
              }
            }
            .rating {
              margin-top: 0.6rem;
              display: flex;
              align-items: center;
              span {
                margin-left: 0.8rem;
                font-size: 1.3rem;
              }
              span.average {
                margin-left: 0;
                margin-right: 0.8rem;
                color: ${(props) => props.theme.colors.greenPantone};
              }
            }
            .hired {
              margin-top: 0.6rem;
              display: flex;
              align-items: center;
              font-size: 1.3rem;
              svg {
                margin-right: 0.6rem;
                width: 1.6rem;
              }
              p {
                margin: 0;
                span {
                  margin-right: 0.6rem;
                }
              }
            }
            p.description {
              font-size: 1.3rem;
              color: #565459;
              word-break: break-all;
            }
          }
        }
        .contact {
          display: none;
        }
      }
    }
  }
  @media (min-width: 768px) {
    padding: 0;
    .results,
    .mobile-filter-steps,
    .mobile-filters {
      max-width: 668px;
      margin-left: auto;
      margin-right: auto;
    }
    .filters-modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 100;
      display: none;
      pointer-events: none;
      &.open {
        display: block;
        pointer-events: inherit;
      }
    }
    .filters-modal {
      width: auto;
      height: auto;
      max-height: 80vh;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  @media (min-width: 1280px) {
    .flex {
      display: flex;
    }
    .mobile-filters {
      display: none;
    }
    .filters-modal-overlay,
    .mobile-filter-steps,
    .filter-floating-button {
      display: none;
    }
    .filters {
      display: block;
      border-right: 1.5px solid #e2e2e9;
      padding: 0 3.2rem;
      max-height: 100vh;
      overflow-y: auto;
      width: 38rem;
      padding-bottom: 10rem;
      span.flex {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        button {
          display: inline-block;
          margin: 0;
          padding: 0;
          border: 0;
          background-color: transparent;
          border: 2px solid var(--color-flickr-blue);
          border-radius: 3rem;
          width: 3rem;
          height: 3rem;
          cursor: pointer;
          svg {
            fill: var(--color-flickr-blue);
            width: 2rem;
            height: auto;
          }
          &:hover {
            background-color: var(--color-flickr-blue);
            svg {
              fill: white;
            }
          }
        }
      }
      .event-time {
        margin-top: 2.4rem;
        h3 {
          font-weight: 600;
          font-size: 1.7rem;
          color: ${(props) => props.theme.colors.jet};
        }

        .date-picker {
          width: 80%;
        }
        .time-date-input {
          width: 80%;
          padding: 1.3rem;
          font-size: 1.4rem;
          border-radius: 0.4rem;
          border: 1px solid #c1c1c1;
        }
      }
      .filter-data {
        margin-top: 3.2rem;
        .filter {
          margin-top: 2.4rem;
          font-size: 1.4rem;
          label {
            display: flex;
            align-items: center;
          }
          input {
            margin-right: 1.2rem;
            width: 2rem;
            height: 2rem;
          }
        }
      }
    }
    .results {
      padding: 0 20px;
      max-width: 740px;
      h1 {
        margin: 3.2rem auto 0;
      }
      .results-data {
        margin: auto;
        .item {
          margin: 2.8rem 0;
          padding-bottom: 2.8rem;
          display: flex;
          .info {
            width: 65%;
          }
          .contact {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: space-between;
            .contact-for-price {
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              font-size: 1.3rem;
              color: #565459;
            }
            a {
              background-color: var(--color-flickr-blue);
              padding: 0.8rem 2.6rem;
              color: white;
              border-radius: 3px;
              font-size: 1.3rem;
            }
          }
        }
      }
    }
  }
`;

// const CustomInput = ({
//     placeholder,
//     value,
//     defaultValue,
//     inputRef,
//     ...props
// }) => {
//     return (
//         <input
//             {...props}
//             placeholder={placeholder}
//             defaultValue={defaultValue}
//             ref={inputRef}
//             className="time-date-input"
//         />
//     );
// };

const SearchResults = ({
    service,
    pros: initialPros,
    proServices,
    lang,
    serviceId,
    questions,
    questionTexts,
    reviews,
}) => {
    const [answers, setAnswers] = useState([]);
    const [filterData, setFilterData] = useState(null);

    const [pros, setPros] = useState(initialPros);
    const [activeFilter, setActiveFilter] = useState(0);
    const [filtersModalOpen, setFiltersModalOpen] = useState(false);
    const [checkedFilters, setCheckedFilters] = useState([]);

    const proServicesByProId = keyBy(proServices, 'proId');
    const reviewsByProId = groupBy(reviews, 'proId');
    const keyedQuestionTextsByQuestionId = groupBy(questionTexts, 'questionId');

    useEffect(() => {
        const applyFilters = async () => {
            const prosData = initialPros.map((pro) => pro.id);

            const { data } = await axios.post('/api/v1/pro/filter', {
                filter: filterData,
                pros: prosData,
            });

            const prosFiltered = initialPros.filter((pro) => {
                const index = data.findIndex((item) => item === pro.id);
                if (index > -1) {
                    return pro;
                }
            });

            setPros(prosFiltered);
        };
        if (filterData) {
            applyFilters();
        }
    }, [filterData]);

    const dispatch = useDispatch();

    const sName =
    lang === 'ru'
        ? service.titleRU
        : lang === 'uz'
            ? service.titleUZ
            : service.titleEN;

    const allFilters = questions.reduce((acc, q) => {
        if (q.filter_show) {
            const allQuestionTexts = keyedQuestionTextsByQuestionId[q.id] || [];
            const filteredQuestionTexts = allQuestionTexts.filter((qu) => qu.belongs === 'client');
            const {
                question,
                description,
                choice,
            } = groupBy(filteredQuestionTexts, 'type');
            const res = {
                ...q,
                choiceText: choice || [],
                description: description || [],
                questionText: question || [],
            };

            acc.push(res);
        }
        return acc;
    }, []);

    const sortedFilters = sortBy(allFilters, 'order');

    dispatch({
        type: QUESTIONS_LOADED,
        payload: {
            serviceId: parseInt(serviceId),
            questions,
        },
    });

    const renderPrice = (proId) => {
        const proService = proServicesByProId[proId];
        if (proService && proService.pricing_display) {
            if (proService.pricing_manual_average) {
                return (
                    <>
                        <h3>{displayPrice(proService.pricing_manual_average)}</h3>
                        <p>{Average_cost[lang]}</p>
                    </>
                );
            }
            if (proService.pricing_manual_hourly_price) {
                return (
                    <>
                        <h3>{displayPrice(proService.pricing_manual_hourly_price)}</h3>
                        <p>{Hourly_cost[lang]}</p>
                    </>
                );
            }
            if (proService.pricing_manual_starting) {
                return (
                    <>
                        <h3>{displayPrice(proService.pricing_manual_starting)}</h3>
                        <p>{starting_cost[lang]}</p>
                    </>
                );
            }
        } else {
            return (
                <>
                    <svg
                        width="24"
                        height="23"
                        viewBox="0 0 24 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M22.5599 10.5199C22.5599 15.5599 17.8559 19.6399 11.9999 19.6399C10.9919 19.6399 10.0319 19.5439 9.11994 19.3039C9.11994 19.3039 7.29594 21.5599 4.31994 21.5599C5.75994 19.4959 5.75994 17.8639 5.75994 17.8639C3.11994 16.1839 1.43994 13.5439 1.43994 10.5199C1.43994 5.4799 6.14394 1.3999 11.9999 1.3999C17.8559 1.3999 22.5599 5.4799 22.5599 10.5199Z"
                            stroke="#565459"
                            strokeWidth="1.859"
                            strokeMiterlimit="10"
                        />
                    </svg>
                    <p>{contact_for_price[lang]}</p>
                </>
            );
        }
    };

    const handleAnswers = async (multiple, e, val, question) => {
        const findQuestionIndex = answers.findIndex(
            (ans) => ans.qid === question.id
        );

        if (e.target.checked) {
            if (findQuestionIndex !== -1) {
                if (!multiple) {
                    answers[findQuestionIndex].values = [val.eng];

                    setAnswers(answers);

                    filterData.values = [val.eng];
                    setFilterData({ ...filterData });

                    const filters = checkedFilters;
                    if (!filters.find((f) => f === question.id)) {
                        filters.push(question.id);
                    }
                    setCheckedFilters(filters);
                } else {
                    answers[findQuestionIndex].values.push(val.eng);

                    setAnswers(answers);

                    filterData.values.push(val.eng);
                    setFilterData({ ...filterData });

                    const filters = checkedFilters;
                    if (!filters.find((f) => f === question.id)) {
                        filters.push(question.id);
                    }
                    setCheckedFilters(filters);
                }
            } else {
                const pushValue = {
                    qid: question.id,
                    values: [val.eng],
                };

                answers.push(pushValue);
                setAnswers(answers);

                setFilterData({
                    qid: question.id,
                    values: [val.eng],
                });

                const filters = checkedFilters;
                if (!filters.find((f) => f === question.id)) {
                    filters.push(question.id);
                }
                setCheckedFilters(filters);
            }
        } else {
            const findValueIndex = answers[findQuestionIndex].values.findIndex(
                (fVal) => fVal == val.eng
            );

            if (findValueIndex !== -1) {
                answers[findQuestionIndex].values.splice(findValueIndex, 1);
                if (answers[findQuestionIndex].values.length === 0) {
                    answers.splice(findQuestionIndex, 1);
                }
            }
        }
    };

    const filtersRef = useRef();
    const mobileFiltersRef = useRef();

    function getCheckboxes() {
        const node_list = filtersRef.current.getElementsByTagName('input');
        const checkboxes = [];
        for (let i = 0; i < node_list.length; i++) {
            const node = node_list[i];
            if (
                node.getAttribute('type') == 'checkbox' ||
        node.getAttribute('type') == 'radio'
            ) {
                checkboxes.push(node);
            }
        }
        return checkboxes;
    }

    function toggle(source) {
        const checkboxes = getCheckboxes();
        const n = checkboxes.length;
        for (let i = 0; i < n; i++) {
            checkboxes[i].checked = source;
        }
    }

    const setCheckboxes = (val) => {
        const node_list = filtersRef.current.getElementsByTagName('label');
        const item = [...node_list].find(
            (node) => node.getAttribute('data-value') === val
        );

        if (item) {
            item.getElementsByTagName('input')[0].checked = true;

            const node_list_mobile = mobileFiltersRef.current.getElementsByTagName(
                'label'
            );
            const itemMobile = [...node_list_mobile].find(
                (node) => node.getAttribute('data-value') === val
            );

            itemMobile.getElementsByTagName('input')[0].checked = true;
        }
    };

    const resetFilters = () => {
        setPros(initialPros);
        setAnswers([]);
        setFilterData(null);
        setCheckedFilters([]);
        toggle(false);

        const node_list_mobile = mobileFiltersRef.current.getElementsByTagName(
            'label'
        );

        [...node_list_mobile].map(
            (node) => (node.getElementsByTagName('input')[0].checked = false)
        );
    };

    const handleFilterMobile = async (val) => {
        const question = sortedFilters[activeFilter].questionText.filter(
            (text) => text.belongs === 'client'
        )[0];

        const findQuestionIndex = answers.findIndex(
            (ans) => ans.qid === question.id
        );

        if (findQuestionIndex !== -1) {
            // QUESTION EXIST
            const valueExists = answers[findQuestionIndex].values.findIndex(
                (value) => value === val
            );

            if (valueExists > -1) {
                // BOTH QUESTION AND ANSWER EXIST
                const ans = answers[findQuestionIndex].values.filter(
                    (ans) => ans !== val
                );
                answers[findQuestionIndex].values = ans;
                filterData.values = ans;
                setFilterData(filterData);

                // REMOVE / UNCHECK
            } else {
                // QUESTION EXISTS, ANSWER DOESN'T

                if (!question.multiple) {
                    answers[findQuestionIndex].values = [val];
                    setCheckboxes(val);
                    setAnswers(answers);

                    filterData.values = [val];
                    setFilterData(filterData);

                    const filters = checkedFilters;
                    if (!filters.find((f) => f === question.id)) {
                        filters.push(question.id);
                    }
                    setCheckedFilters(filters);
                } else {
                    answers[findQuestionIndex].values.push(val);
                    setCheckboxes(val);
                    setAnswers(answers);

                    filterData.values.push(val);
                    setFilterData(filterData);

                    const filters = checkedFilters;
                    if (!filters.find((f) => f === question.id)) {
                        filters.push(question.id);
                    }
                    setCheckedFilters(filters);
                }
            }
        } else {
            // QUESTION DON'T EXIST
            const pushValue = {
                qid: question.id,
                values: [val],
            };

            answers.push(pushValue);
            setCheckboxes(val);

            setAnswers(answers);

            setFilterData({
                qid: sortedFilters[activeFilter].id,
                values: [val],
            });

            const filters = checkedFilters;
            if (!filters.find((f) => f === question.id)) {
                filters.push(question.id);
            }
            setCheckedFilters(filters);

            if (!question.multiple && activeFilter + 1 < sortedFilters.length) {
                setActiveFilter(activeFilter + 1);
            }
        }
    };

    const checkIsActive = (question, choice) => {
        const questionInArray = answers.find((ans) => ans.qid === question.id);
        if (questionInArray) {
            const index = questionInArray.values.findIndex((val) => val === choice);
            if (index > -1) {
                return 'active';
            } else {
                return '';
            }
        } else {
            return '';
        }
    };

    return (
        <SearchCss>
            {sortedFilters.length > 0 && (
                <div className="filter-floating-button">
                    <button onClick={() => setFiltersModalOpen(true)}>
                        {answers.length > 0 && answers.length} {Filters[lang]}
                    </button>
                </div>
            )}
            <div
                className={
                    filtersModalOpen
                        ? 'filters-modal-overlay open'
                        : 'filters-modal-overlay'
                }
            >
                <div
                    className={filtersModalOpen ? 'filters-modal open' : 'filters-modal'}
                >
                    <div className="close">
                        <button onClick={() => setFiltersModalOpen(false)}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="28"
                                height="28"
                                viewBox="0 0 24 24"
                            >
                                <path d="M16.192 6.344L11.949 10.586 7.707 6.344 6.293 7.758 10.535 12 6.293 16.242 7.707 17.656 11.949 13.414 16.192 17.656 17.606 16.242 13.364 12 17.606 7.758z"></path>
                            </svg>
                        </button>
                    </div>
                    <div className="filters-content" ref={mobileFiltersRef}>
                        <div className="header">
                            <h3>{Filter[lang]}</h3>
                            <button onClick={resetFilters}>{Reset[lang]}</button>
                        </div>
                        {sortedFilters.map((filter) => {
                            const qTitle = filter.questionText.filter(
                                (t) => t.belongs === 'client'
                            );

                            const choices = filter.choiceText.filter(
                                (c) => c.belongs === 'client'
                            );

                            if (qTitle.length > 0 && choices.length) {
                                const title =
                  lang === 'ru'
                      ? qTitle[0].ru
                      : lang === 'uz'
                          ? qTitle[0].uz
                          : qTitle[0].eng;

                                return (
                                    <div key={filter.id} className="filter-data">
                                        <h3>{title}</h3>
                                        {choices.map((choice) => {
                                            return (
                                                <div key={choice.id} className="filter">
                                                    <label data-value={choice.eng} className="container">
                                                        {qTitle[0].multiple ? (
                                                            <input
                                                                type="checkbox"
                                                                onChange={(e) =>
                                                                    handleAnswers(true, e, choice, filter)
                                                                }
                                                            />
                                                        ) : (
                                                            <input
                                                                type="radio"
                                                                name={title}
                                                                onChange={(e) =>
                                                                    handleAnswers(false, e, choice, filter)
                                                                }
                                                            />
                                                        )}
                                                        <span className="filter-name">
                                                            {lang === 'ru'
                                                                ? choice.ru
                                                                : lang === 'uz'
                                                                    ? choice.uz
                                                                    : choice.eng}
                                                        </span>
                                                    </label>
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            }
                        })}
                    </div>
                    <div className="modal-footer">
                        <button onClick={() => setFiltersModalOpen(false)}>
                            {Save[lang]}
                        </button>
                    </div>
                </div>
            </div>
            <div className="mobile-filter-steps">
                {sortedFilters[activeFilter] && (
                    <>
                        <div className="filter-header">
                            <h3>
                                {
                                    sortedFilters[activeFilter].questionText.filter(
                                        (text) => text.belongs === 'client'
                                    )[0][lang]
                                }
                            </h3>
                            {activeFilter + 1 < sortedFilters.length && (
                                <button onClick={() => setActiveFilter(activeFilter + 1)}>
                                    {Skip[lang]} &#8250;
                                </button>
                            )}
                        </div>
                        <div className="filter-options">
                            {sortedFilters[activeFilter].choiceText
                                .filter((choice) => choice.belongs === 'client')
                                .map((choice) => (
                                    <button
                                        key={choice.id}
                                        className={checkIsActive(
                                            sortedFilters[activeFilter].questionText.filter(
                                                (text) => text.belongs === 'client'
                                            )[0],
                                            choice.eng
                                        )}
                                        onClick={() => handleFilterMobile(choice.eng)}
                                    >
                                        {lang === 'ru'
                                            ? choice.ru
                                            : lang === 'uz'
                                                ? choice.uz
                                                : choice.eng}

                                    </button>
                                ))}
                        </div>
                    </>
                )}
            </div>
            <div className="flex">
                <div className="filters" ref={filtersRef}>
                    <span className="flex">
                        <h1>{Filter[lang]}</h1>
                        {filterData && (
                            <button onClick={resetFilters}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path d="M16.192 6.344L11.949 10.586 7.707 6.344 6.293 7.758 10.535 12 6.293 16.242 7.707 17.656 11.949 13.414 16.192 17.656 17.606 16.242 13.364 12 17.606 7.758z"></path>
                                </svg>
                            </button>
                        )}
                    </span>
                    <div className="event-time">
                        {sortedFilters.map((filter) => {
                            const qTitle = filter.questionText.filter(
                                (t) => t.belongs === 'client'
                            );

                            const choices = filter.choiceText.filter(
                                (c) => c.belongs === 'client'
                            );

                            if (qTitle.length > 0 && choices.length) {
                                const title =
                  lang === 'ru'
                      ? qTitle[0].ru
                      : lang === 'uz'
                          ? qTitle[0].uz
                          : qTitle[0].eng;

                                return (
                                    <div key={filter.id} className="filter-data">
                                        <h3>{title}</h3>
                                        {choices.map((choice) => {
                                            return (
                                                <div key={choice.id} className="filter">
                                                    <label data-value={choice.eng} className="container">
                                                        {qTitle[0].multiple ? (
                                                            <input
                                                                type="checkbox"
                                                                onChange={(e) =>
                                                                    handleAnswers(true, e, choice, filter)
                                                                }
                                                            />
                                                        ) : (
                                                            <input
                                                                type="radio"
                                                                name={title}
                                                                onChange={(e) =>
                                                                    handleAnswers(false, e, choice, filter)
                                                                }
                                                            />
                                                        )}
                                                        <span className="filter-name">
                                                            {lang === 'ru'
                                                                ? choice.ru
                                                                : lang === 'uz'
                                                                    ? choice.uz
                                                                    : choice.eng}
                                                        </span>
                                                    </label>
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            }
                        })}
                    </div>
                </div>
                <div className="results">
                    {sName && <h1>{sName}</h1>}
                    <div className="results-data">
                        {pros ? (
                            pros.length === 0 ? (
                                <h1>{No_pros_with_your_choice_yet[lang]}</h1>
                            ) : (
                                pros.map((result, i) => {
                                    return (
                                        <Fragment key={i}>
                                            { !result.hide_pro&&
                    <div key={i} className="item">
                        <div className="info">
                            <a
                                href={'/details/' + result.id + '?sid=' + serviceId}
                            >

                                <div className="image">
                                    <Image
                                        layout="fill"
                                        src={
                                            result.profile_image
                                                ? process.env.ASSETS_URL +
                                      '/' +
                                      result.profile_image
                                                : '/assets/images/topx-user.jpg'
                                        }
                                        alt={result.name}
                                    />
                                </div>

                            </a>
                            <div className="details">
                                <h2>
                                    <Link
                                        href={
                                            '/details/' + result.id + '?sid=' + serviceId
                                        }
                                    >
                                        {result.name}
                                    </Link>
                                </h2>
                                <div className="rating">
                                    <span className="average">
                                        {Number(result.review_average&&result.review_average.toFixed(1))}
                                    </span>
                                    {result.review_average&&result.review_average.toFixed(1) >= 1 ? (
                                        <Star />
                                    ) : (
                                        <GreyStar />
                                    )}
                                    {result.review_average&&result.review_average.toFixed(1) >= 2 ? (
                                        <Star />
                                    ) : (
                                        <GreyStar />
                                    )}
                                    {result.review_average&&result.review_average.toFixed(1) >= 3 ? (
                                        <Star />
                                    ) : (
                                        <GreyStar />
                                    )}
                                    {result.review_average&&result.review_average.toFixed(1) >= 4 ? (
                                        <Star />
                                    ) : (
                                        <GreyStar />
                                    )}
                                    {result.review_average&&result.review_average.toFixed(1) == 5 ? (
                                        <Star />
                                    ) : (
                                        <GreyStar />
                                    )}
                                    <span className="reviews-number">
                              ({(reviewsByProId[result.id] || []).length})
                                    </span>
                                </div>
                                <div className="hired">
                                    <Trophy />
                                    <p>
                                        <span>{result.overview_hired || 0}</span>
                                        {Hired[lang]}
                                    </p>
                                </div>
                                <p className="description">
                                    {result.description &&
                              result.description.slice(0, 100) + '...'}
                                </p>
                            </div>
                        </div>
                        <div className="contact">
                            <div className="contact-for-price">
                                {renderPrice(result.id)}
                            </div>
                            <a
                                href={'/details/' + result.id + '?sid=' + serviceId}
                            >
                                <div className="visit-profile">{View_profile[lang]}</div>
                            </a>
                        </div>
                    </div>
                                            }
                                        </Fragment>

                                    );
                                })
                            )
                        ) : (
                            <h1>Pros loading...</h1>
                        )}
                    </div>
                </div>
            </div>
        </SearchCss>
    );
};

export default memo(SearchResults);
